var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHuntingtonBank = function SvgHuntingtonBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "huntington-bank_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".huntington-bank_svg__st1{fill:#70b62c}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0 0h40v26H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "huntington-bank_svg__Calque_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "huntington-bank_svg__st1",
    d: "M19.545 8.97V2.34L17.14 3.77v6.565zM20.455 17.03v6.63l2.405-1.43v-6.565z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "huntington-bank_svg__st1",
    d: "M17.14 15.145v7.085l2.405 1.43v-7.085l4.16-2.405v7.54l2.405-1.365V5.655L23.705 4.29v7.085z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "huntington-bank_svg__st1",
    d: "m16.23 4.29-2.34 1.365v14.69l2.34 1.365v-7.085l6.63-3.77V3.77l-2.405-1.43v7.085L16.23 11.83zM12.915 6.175 10.9 7.345c-.195.13-.39.39-.39.52v10.14c0 .195.195.455.39.52l2.015 1.17V6.175zM27.085 19.825l2.015-1.17c.195-.13.39-.39.39-.52V7.93c0-.195-.195-.455-.39-.52l-2.015-1.17v13.585z"
  }))));
};
export default SvgHuntingtonBank;